import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="text-white" style={{ backgroundColor: '#1570EF', borderTop: '4px solid white' }}>
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Column 1: About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_pharma-compliance-7/artifacts/2ycn5ziy_Gemini_Generated_Image_9vta8x9vta8x9vta-Photoroom.png"
                alt="Pegasus Clinicare Logo"
                className="h-28 w-auto"
              />
            </div>
            <p className="text-sm" style={{ color: '#FFFFFF' }}>
              Your trusted partner in regulatory excellence and global drug sourcing. Enabling seamless market access for pharmaceutical, medical device, cosmetic, and food industry organizations since 2014.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="w-10 h-10 rounded-full bg-[#1570EF] flex items-center justify-center hover:bg-[#1E40AF] transition-colors duration-200"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-twitter"
                className="w-10 h-10 rounded-full bg-[#1570EF] flex items-center justify-center hover:bg-[#1E40AF] transition-colors duration-200"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/industries" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Industries
                </Link>
              </li>
              <li>
                <Link to="/why-pegasus" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Why Pegasus
                </Link>
              </li>
              <li>
                <Link to="/clients" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Clients
                </Link>
              </li>
              <li>
                <Link to="/knowledge-hub" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Knowledge Hub
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/fda" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  FDA Regulatory Compliance
                </Link>
              </li>
              <li>
                <Link to="/services/cdsco" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  CDSCO Regulatory Compliance
                </Link>
              </li>
              <li>
                <Link to="/services/global-regulatory" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Global Regulatory Compliance
                </Link>
              </li>
              <li>
                <Link to="/services/gmp" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Revised Schedule M GMP Advisory
                </Link>
              </li>
              <li>
                <Link to="/services/who-gmp" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  WHO GMP Certification Advisory
                </Link>
              </li>
              <li>
                <Link to="/services/specialized" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Specialized Regulatory Consultation
                </Link>
              </li>
              <li>
                <Link to="/services/facility-design" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Facility Design & Consultancy
                </Link>
              </li>
              <li>
                <Link to="/services/turnkey" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Turnkey Key Project
                </Link>
              </li>
              <li>
                <Link to="/services/drug-sourcing" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
                  Global Drug Sourcing
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm" style={{ color: '#FFFFFF' }}>
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>India</span>
              </li>
              <li className="flex items-start gap-2 text-sm" style={{ color: '#FFFFFF' }}>
                <Phone size={16} className="mt-0.5 flex-shrink-0" />
                <div>
                  <div>+91 9850271210 (Pravin Jagtap)</div>
                  <div className="mt-1">+91 9158487862 (Jayesh Salunke)</div>
                </div>
              </li>
              <li className="flex items-start gap-2 text-sm" style={{ color: '#FFFFFF' }}>
                <Mail size={16} className="mt-0.5 flex-shrink-0" />
                <div>pravin@pegasusclinicare.com</div><div>jayesh@pegasusclinicare.com</div>
              </li>
              <li className="text-sm" style={{ color: '#FFFFFF' }}>
                <div className="font-semibold mb-1">Office Hours:</div>
                <div>Mon-Sat | 9:00 AM - 6:00 PM IST</div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#FFFFFF]/20 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm" style={{ color: '#FFFFFF' }}>
            © 2025 Pegasus Clinicare Pvt. Ltd. All Rights Reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
              Terms of Use
            </Link>
            <Link to="/sitemap" className="text-sm hover:text-[#1570EF] transition-colors duration-200" style={{ color: '#FFFFFF' }}>
              Sitemap
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;